"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _inline_svg = require("./inline_svg.utils");
var _inline_svg2 = _interopRequireDefault(require("./inline_svg.proptypes"));
const SportsEquipment = props => {
  const {
    fontsize,
    themeColor,
    ...rest
  } = props;
  const theme = _react.default.useContext(_styledComponents.ThemeContext);
  const {
    sizeStyles,
    colorStyles
  } = (0, _inline_svg.parseStyles)({
    fontsize,
    themeColor
  }, theme);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, sizeStyles, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/_react.default.createElement("path", (0, _extends2.default)({
    // eslint-disable-next-line max-len
    d: "M4.39027 22.4456L3.68594 23.0002L2.98162 20.7201H2.65654C2.65654 20.7201 0.326858 6.54646 4.44444 1.00024V22.4456H4.39027Z",
    fill: "#75767A"
  }, colorStyles)), /*#__PURE__*/_react.default.createElement("path", (0, _extends2.default)({
    // eslint-disable-next-line max-len
    d: "M5.31346 22.4456L6.01778 23.0002L6.7221 20.7201H7.04718C7.04718 20.7201 9.37686 6.54646 5.25928 1.00024V22.4456H5.31346Z",
    fill: "#75767A"
  }, colorStyles)), /*#__PURE__*/_react.default.createElement("path", (0, _extends2.default)({
    // eslint-disable-next-line max-len
    d: "M20.742 7.59421C22.019 7.29149 21.4109 6.14116 21.4109 6.14116L19.7689 5.95953C18.9784 5.89899 18.7351 6.38334 18.7351 6.38334L17.3972 10.0765L16.8499 10.2581L16.485 3.9616C16.485 3.29562 15.9985 3.11399 15.9985 3.11399L14.2958 2.62964C12.8971 3.05344 14.1133 4.26431 14.1133 4.26431L15.6945 4.32486L15.8769 10.3187L14.9039 10.5608L13.0187 5.53573C12.8363 5.05138 12.3498 5.05138 12.3498 5.05138L10.5862 5.17247C9.36992 6.26225 11.0727 6.80714 11.0727 6.80714L12.4106 6.38334L14.1133 10.6819C12.9579 10.803 12.9579 11.5295 12.9579 11.5295C11.0727 12.135 11.0727 15.2227 11.0727 15.2227C11.0727 18.1893 12.8971 19.7635 12.8971 19.7635V21.3376C12.8971 22.0036 13.8093 22.1852 13.8093 22.1852H18.127C19.3433 22.1852 19.1608 21.0349 19.1608 21.0349H20.1338C20.8028 20.9743 20.742 20.3689 20.742 20.3689V16.5546C20.742 15.8887 20.1338 15.8887 20.1338 15.8887L19.2216 15.9492V13.5275C20.2554 13.588 20.1946 12.922 20.1946 12.922L20.1338 11.0452C20.073 10.3792 19.1608 10.5608 19.1608 10.5608C19.0392 9.77377 18.3094 9.77377 18.3094 9.77377L19.4649 7.1704L20.742 7.59421ZM12.8363 18.1893C11.1335 14.1935 12.8363 12.6799 12.8363 12.6799V18.1893Z",
    fill: "#75767A"
  }, colorStyles)));
};
SportsEquipment.propTypes = _inline_svg2.default.propTypes;
SportsEquipment.defaultProps = _inline_svg2.default.defaultProps;
var _default = exports.default = SportsEquipment;